import styled from "@emotion/styled";
import * as React from "react";

import { Button } from "@livechat/design-system";
import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { IWithTestSelector } from "components/interfaces";
import { withVar } from "themes/helpers";

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-end;

  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    align-self: center;
  }
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

interface IStyledContainerProps {
  disabled: boolean;
}

const StyledIconContainer = styled.div<IStyledContainerProps>`
  align-items: center;
  cursor: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.disabled ? "default" : "pointer")
  };
  display: inline-flex;
  height: 16px;
  justify-content: center;
  margin-right: 8px;
  width: 16px;

  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    height: 24px;
    width: 24px;
  }
`;

interface IToolbarIconProps extends IWithTestSelector {
  icon: string;
  disabled: boolean;
  privateMode: boolean;
  mobile: boolean;
  onClick(event?: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
  onMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
}

export const ToolbarIcon: React.FC<IToolbarIconProps> = ({
  icon,
  disabled,
  privateMode,
  mobile,
  onClick,
  onMouseDown,
}) => {
  const size = mobile ? "18px" : "14px";
  const fill = withVar(privateMode ? DesignToken.ContentInvertPrimary : DesignToken.ActionPrimaryDefault);
  return (
    <StyledIconContainer disabled={disabled} onClick={onClick} onMouseDown={onMouseDown}>
      <Icon name={icon} width={size} height={size} fill={fill} inline />
    </StyledIconContainer>
  );
};

export interface IToolbarProps {
  disabled: boolean;
  attachmentsEnabled: boolean;
  mobile: boolean;
  privateMode?: boolean;
  leftNodes?: React.ReactNode;
  rightNodes?: React.ReactNode;
  sendButtonLabel?: string;
  sendButtonDisabled?: boolean;
  sendButtonLoading?: boolean;
  onCannedResponseClick(): void;
  onAttachmentClick(): void;
  onSendButtonClick(e: React.MouseEvent<HTMLButtonElement>): void;
  onSendButtonMouseDown(e: React.MouseEvent<HTMLButtonElement>): void;
}

export class Toolbar extends React.PureComponent<IToolbarProps> {
  static defaultProps = {
    privateMode: false,
    leftNodes: null,
    rightNodes: null,
    sendButtonLabel: "Send",
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleCannedResponseClick = () => {
    if (!this.props.disabled) {
      this.props.onCannedResponseClick();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleAttachmentClick = () => !this.props.disabled && this.props.onAttachmentClick();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSendButtonMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!this.props.disabled) {
      this.props.onSendButtonMouseDown(e);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSendButtonClick = (e: React.MouseEvent<HTMLButtonElement>) =>
    !this.props.disabled && this.props.onSendButtonClick(e);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  preventMouseDown = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      sendButtonLabel,
      disabled,
      sendButtonDisabled,
      sendButtonLoading,
      privateMode,
      leftNodes,
      rightNodes,
      mobile,
      attachmentsEnabled,
    } = this.props;
    return (
      <StyledContainer>
        <StyledIconsWrapper>
          {leftNodes}
          <ToolbarIcon
            testSelector="canned-responses-button"
            icon={IconsEnum.CannedResponse}
            disabled={disabled}
            // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
            privateMode={privateMode}
            mobile={mobile}
            onClick={this.handleCannedResponseClick}
            onMouseDown={this.preventMouseDown}
          />
          {attachmentsEnabled && (
            <ToolbarIcon
              testSelector="attachments-button"
              icon={IconsEnum.Attachment}
              disabled={disabled}
              // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
              privateMode={privateMode}
              mobile={mobile}
              onClick={this.handleAttachmentClick}
              onMouseDown={this.preventMouseDown}
            />
          )}
        </StyledIconsWrapper>
        <StyledButtonWrapper>
          {rightNodes}
          <Button
            kind="primary"
            size="compact"
            disabled={sendButtonDisabled || disabled}
            loading={sendButtonLoading}
            onClick={this.handleSendButtonClick}
            onMouseDown={this.handleSendButtonMouseDown}
          >
            {sendButtonLabel}
          </Button>
        </StyledButtonWrapper>
      </StyledContainer>
    );
  }
}
